module.exports = __webpack_public_path__ + "img/layout-v1.66f23c71.jpg";